import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { TranslateService } from './translate.service';

@Directive({
    selector: '[appTranslate]',
    providers: [TranslateService],
    standalone: false
})
export class TranslateDirective {

  constructor(
    private elementRef: ElementRef,
    private render: Renderer2,
    private translateService: TranslateService
  ) {}

  @Input() set translate(key: string) {
    const phrase = this.translateService.translate(key);
    if (phrase) {
      this.render.setProperty(this.elementRef.nativeElement, 'innerHTML', phrase);
    }
  }

}
